export const getPreviousWrappingIndex = (currentIndex: number, listLength: number): number =>
  currentIndex - 1 >= 0 ? currentIndex - 1 : listLength - 1;
